import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../calculations/static/calculations/ts/features/metric-selector-modal/components/single-metric-selector-modal/single-metric-selector-modal.component";
import * as i2 from "NewAngular/features/components/modals/loading-modal/loading-modal.component";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../search/static/search/ts/features/base-autocomplete/components/base-autocomplete.component";
const _c0 = a0 => ({ open: a0 });
/**
 * Autocomplete wrapper component to be used in Django Templates for security data tabs.
 */
export class DataTabAutocompleteComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.loading = false;
        this.defaultOnly = false;
        this.baseDataUrl = this.eltRef.nativeElement.getAttribute('baseDataUrl');
        this.searchType = this.eltRef.nativeElement.getAttribute('searchType');
        this.defaultOnly = eltRef.nativeElement.getAttribute('defaultOnly') === 'True';
    }
    selectMetricHandler(metric) {
        this.loading = true;
        window.location.href = this.baseDataUrl.replace('__metric__', metric);
    }
}
DataTabAutocompleteComponent.ɵfac = function DataTabAutocompleteComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DataTabAutocompleteComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
DataTabAutocompleteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTabAutocompleteComponent, selectors: [["ycn-data-tab-autocomplete"]], standalone: false, decls: 12, vars: 11, consts: [["metricSelectorModal", ""], [1, "label", "form-label", "form-label-small"], [1, "form-inline"], [1, "form-group"], [1, "input-group", 3, "submitHandler", "placeholder", "buttonType", "searchType", "defaultOnly"], [1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "loadingText", "modalTrigger"], [3, "submitModalHandler", "submitModalAutocompleteHandler", "searchType", "defaultOnly"]], template: function DataTabAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵtext(1, "View 4,000+ Financial Data Types:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "ycn-base-autocomplete", 4);
        i0.ɵɵlistener("submitHandler", function DataTabAutocompleteComponent_Template_ycn_base_autocomplete_submitHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectMetricHandler($event.search_id)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵlistener("click", function DataTabAutocompleteComponent_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r1); const metricSelectorModal_r2 = i0.ɵɵreference(11); return i0.ɵɵresetView(metricSelectorModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 6);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵtext(8, "Browse");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(9, "ycn-loading-modal", 7);
        i0.ɵɵelementStart(10, "ycn-single-metric-selector-modal", 8, 0);
        i0.ɵɵlistener("submitModalHandler", function DataTabAutocompleteComponent_Template_ycn_single_metric_selector_modal_submitModalHandler_10_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectMetricHandler($event.internal_name)); })("submitModalAutocompleteHandler", function DataTabAutocompleteComponent_Template_ycn_single_metric_selector_modal_submitModalAutocompleteHandler_10_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectMetricHandler($event.search_id)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("placeholder", "Search")("buttonType", "add")("searchType", ctx.searchType)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-browse");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("loadingText", "Loading requested data...")("modalTrigger", i0.ɵɵpureFunction1(9, _c0, ctx.loading));
        i0.ɵɵadvance();
        i0.ɵɵproperty("searchType", ctx.searchType)("defaultOnly", ctx.defaultOnly);
    } }, dependencies: [i1.SingleMetricSelectorModalComponent, i2.LoadingModalComponent, i3.IconDirective, i4.BaseAutocompleteComponent], encapsulation: 2 });
